import { AnyAction } from 'redux';

import slice from '../reducer/slice';
import {
  AvailabilityType,
  FuelType,
} from 'pages/Map/components/FuelAvailabilityButton/constants';
import { RestrictionStatus } from 'dataSources/Typicode/stations/types/stationInfo';

type TOperation = (restrictions: {
  serviceNtType: FuelType | string;
  mode: AvailabilityType;
  statuses: Array<RestrictionStatus>;
}) => AnyAction;

const operation: TOperation = (restrictions) =>
  slice.actions.setRestrictions(restrictions);

export default operation;
